// 知识主题

import { useMemo } from 'react';
import { theme } from 'antd';

const useLarkTheme = () => {
  return useMemo(
    () => ({
      theme: {
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#00B96B',
          borderRadius: 4,
        },
        components: {
          Layout: {
            bodyBg: '#f7fbf8',
            footerBg: '#f7fbf8',
            headerBg: '#ffffff',
            headerColor: '#1f2329',
            siderBg: '#ffffff',
            triggerBg: '#eff7f2',
            triggerColor: '#1f2329',
          },
          Menu: {
            activeBarBorderWidth: 0,
            itemBg: 'transparent',
            subMenuItemBg: 'transparent',
          },
          Progress: {
            circleTextColor: '#1f2329',
            defaultColor: '#00B96B',
            remainingColor: 'rgba(0, 185, 107, 0.12)',
          },
        },
      },
    }),
    [],
  );
};

export default useLarkTheme;
